var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-stepper-step",
        {
          attrs: {
            complete: _vm.step > 2,
            step: "3"
          }
        },
        [_vm._v(" Promotion Requested ")]
      ),
      _c(
        "v-stepper-content",
        {
          attrs: {
            step: "3"
          }
        },
        [
          _c("p", [_vm._v("Your promotion request has been received.")]),
          _c("p", [
            _c(
              "strong",
              [
                _vm._v(" Confirmation Number: "),
                _c(
                  "router-link",
                  {
                    attrs: {
                      to: {
                        name: "promotion_view",
                        params: {
                          promo_id: _vm.promoRequestId
                        }
                      }
                    }
                  },
                  [_vm._v(" #" + _vm._s(_vm.promoRequestId) + " ")]
                )
              ],
              1
            )
          ]),
          _c(
            "p",
            [
              _vm._v(
                "You may view and monitor your request or return to the Dashboard. Find your promotion history at "
              ),
              _c(
                "router-link",
                {
                  attrs: {
                    to: {
                      name: "promotions_list",
                      params: {
                        promo_id: _vm.promoRequestId
                      }
                    }
                  }
                },
                [_c("strong", [_vm._v("My Promotions")])]
              ),
              _vm._v(". ")
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    color: "primary",
                    tile: "",
                    elevation: "0",
                    to: {
                      name: "promotion_view",
                      params: {
                        promo_id: _vm.promoRequestId
                      }
                    }
                  }
                },
                [_vm._v(" View Request ")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    tile: "",
                    elevation: "0",
                    color: "gray"
                  },
                  on: {
                    click: _vm.redirectToDashboard
                  }
                },
                [_vm._v("Return to Dashboard")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }